/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './radiology-report-template.reducer';

export const RadiologyReportTemplateDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const radiologyReportTemplateEntity = useAppSelector(state => state.radiologyReportTemplate.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="radiologyReportTemplateDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.detail.title">RadiologyReportTemplate</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.id">Id</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.id}</dd>
          <dt>
            <span id="charset">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.charset">Charset</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.charset}</dd>
          <dt>
            <span id="path">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.path">Path</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.path}</dd>
          <dt>
            <span id="reportBody">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.reportBody">Report Body</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.reportBody}</dd>
          <dt>
            <span id="dcTermsTitle">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsTitle">Dc Terms Title</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.dcTermsTitle}</dd>
          <dt>
            <span id="dcTermsDescription">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsDescription">Dc Terms Description</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.dcTermsDescription}</dd>
          <dt>
            <span id="dcTermsIdentifier">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsIdentifier">Dc Terms Identifier</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.dcTermsIdentifier}</dd>
          <dt>
            <span id="dcTermsType">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsType">Dc Terms Type</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.dcTermsType}</dd>
          <dt>
            <span id="dcTermsLanguage">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsLanguage">Dc Terms Language</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.dcTermsLanguage}</dd>
          <dt>
            <span id="dcTermsPublisher">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsPublisher">Dc Terms Publisher</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.dcTermsPublisher}</dd>
          <dt>
            <span id="dcTermsRights">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsRights">Dc Terms Rights</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.dcTermsRights}</dd>
          <dt>
            <span id="dcTermsLicense">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsLicense">Dc Terms License</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.dcTermsLicense}</dd>
          <dt>
            <span id="dcTermsDate">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsDate">Dc Terms Date</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.dcTermsDate}</dd>
          <dt>
            <span id="dcTermsCreator">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dcTermsCreator">Dc Terms Creator</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.dcTermsCreator}</dd>
          <dt>
            <span id="voided">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.voided">Voided</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.voided ? 'true' : 'false'}</dd>
          <dt>
            <span id="dateVoided">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.dateVoided">Date Voided</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.dateVoided}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.timestampEntry}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.lastUpdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.active">Active</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="associationType">
              <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.associationType">Association Type</Translate>
            </span>
          </dt>
          <dd>{radiologyReportTemplateEntity.associationType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.doctor">Doctor</Translate>
          </dt>
          <dd>{radiologyReportTemplateEntity.doctor ? radiologyReportTemplateEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.lab">Lab</Translate>
          </dt>
          <dd>{radiologyReportTemplateEntity.lab ? radiologyReportTemplateEntity.lab.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.test">Test</Translate>
          </dt>
          <dd>{radiologyReportTemplateEntity.test ? radiologyReportTemplateEntity.test.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.panel">Panel</Translate>
          </dt>
          <dd>{radiologyReportTemplateEntity.panel ? radiologyReportTemplateEntity.panel.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiologyReportTemplate.testItem">Test Item</Translate>
          </dt>
          <dd>{radiologyReportTemplateEntity.testItem ? radiologyReportTemplateEntity.testItem.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/radiology-report-template" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/radiology-report-template/${radiologyReportTemplateEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RadiologyReportTemplateDetail;
